import { isNil } from 'lodash-es'
import { FunctionComponent } from 'react'

import { GetDataEntry } from '../../../domain'
import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const LookupFormatter: FunctionComponent<Formatter<string | GetDataEntry>> = ({
  value,
  t,
}) => {
  if (isNil(value)) {
    return t(tDefaults('inputs.no-answer'))
  }

  return typeof value === 'string' ? value : value.name
}
